// extracted by mini-css-extract-plugin
export const text = "PlaceholderParagraph-module--text--2MJPI";